"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

var _moment = _interopRequireDefault(require("moment"));

var _add_to_calendar = _interopRequireDefault(require("hbars!../templates/add_to_calendar"));

var _config = _interopRequireDefault(require("config"));

var _FeatureToggleUtils = _interopRequireDefault(require("../utils/FeatureToggleUtils"));

var _whitelabelUtils = require("../utils/whitelabelUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calendarTypes = {
  google: 'GOOGLE',
  yahoo: 'YAHOO',
  ics: 'ICALENDAR'
};

var AddToCalendarView = _backbone.default.View.extend({
  events: {},
  MS_IN_MINUTES: 60 * 1000,
  NUMBER_OF_CHARACTER_TRIM: 3000,
  initialize: function initialize(options) {
    this.event = options.event || {};
    this.session = options.session || false;
    this.eventMode = !this.session;
    this.model = new _backbone.default.Model();
    this.eventWithTime = options.eventWithTime;
    this.generateLinks();
  },
  generateLinks: function generateLinks() {
    var startTime, endTime;

    if (this.eventMode) {
      var eventStartTimeAndHour = (0, _moment.default)(this.event.get('local-start-date'), this.event.dateFormat);
      var eventEndTimeAndHour = (0, _moment.default)(this.event.get('local-end-date'), this.event.dateFormat);

      var eventStartTimeAndHourUTC = _moment.default.utc(this.event.get('start-date'));

      var eventEndTimeAndHourUTC = _moment.default.utc(this.event.get('end-date'));

      var venue = this.event.get('venue') || {};
      this.model.set({
        title: this.event.get('name'),
        start: eventStartTimeAndHour && new Date(eventStartTimeAndHour.valueOf()),
        end: eventEndTimeAndHour && new Date(eventEndTimeAndHour.valueOf()),
        momentStart: eventStartTimeAndHour,
        momentEnd: eventEndTimeAndHour,
        momentStartUTC: eventStartTimeAndHourUTC,
        momentEndUTC: eventEndTimeAndHourUTC,
        address: venue['display-address'] || venue.name || '',
        description: this.event.get('description') && this.event.get('description').toString().substring(0, this.NUMBER_OF_CHARACTER_TRIM)
      });
    } else {
      var sessionTime = (0, _moment.default)(this.session.get('start'), 'H:mm');
      startTime = (0, _moment.default)(this.event.get('local-start-date'), this.event.dateFormat).startOf('day').add({
        days: this.session.get('dayIndex')
      }).hours(sessionTime.hours()).minutes(sessionTime.minutes());
      endTime = (0, _moment.default)(startTime).add(this.session.get('duration'), 'm');

      var momentStartUTC = _moment.default.utc(startTime);

      var momentEndUTC = _moment.default.utc(endTime);

      this.model.set({
        title: this.session.get('name'),
        start: new Date(startTime.valueOf()),
        end: new Date(endTime.valueOf()),
        momentStart: startTime,
        momentEnd: endTime,
        momentStartUTC: momentStartUTC,
        momentEndUTC: momentEndUTC,
        address: this.session.get('location'),
        description: this.session.get('description') && this.session.get('description').toString().substring(0, this.NUMBER_OF_CHARACTER_TRIM)
      });
    }

    this.google();
    this.yahoo();
    this.ics();
  },
  formatTime: function formatTime(date) {
    return date.toISOString().replace(/-|:|\.\d+/g, '');
  },
  formatMomentTime: function formatMomentTime(date) {
    var lengthWithoutTimeZoneInformation = 15;
    return date.format().replace(/-|:|\.\d+/g, '').substring(0, lengthWithoutTimeZoneInformation);
  },
  getCalendarUrl: function getCalendarUrl(type) {
    var websiteType = this.event.get('websiteType');
    var whitelabelUrl = this.event.get('whitelabelUrl');
    var eventsDomain = websiteType === 'whitelabel' ? "https://".concat(whitelabelUrl) : _config.default.eventsUrl;
    var calendarUrl = "".concat(eventsDomain, "/calendars/").concat(calendarTypes[type], "/accounts/").concat(this.event.get('account-id'), "/events/").concat(this.event.id);

    if (this.session) {
      calendarUrl += "/session/".concat(this.session.id);
    }

    return calendarUrl;
  },
  google: function google() {
    var isNewCalendarLinksEnabled = _FeatureToggleUtils.default.isFeatureEnabled('new-calendar-links');

    if (isNewCalendarLinksEnabled) {
      this.model.set('google', this.getCalendarUrl('google'));
      return;
    }

    var startTime = this.formatMomentTime(this.model.get('momentStart'));
    var endTime = this.formatMomentTime(this.model.get('momentEnd'));
    var description = this.model.get('description') || '';
    var urlToAdd = this.event.getAgendaUrl ? this.event.getAgendaUrl() : '';
    var params = ['https://www.google.com/calendar/render', '?action=TEMPLATE', '&text=' + encodeURIComponent(this.model.get('title') || ''), '&dates=' + encodeURIComponent(startTime || ''), '/' + encodeURIComponent(endTime || ''), '&details=' + encodeURIComponent(description + '\n\n' + urlToAdd), '&location=' + encodeURIComponent(this.model.get('address') || ''), '&sprop=&sprop=name:'];

    if (this.event.get('time-zone-id')) {
      params.push('&ctz=' + this.event.get('time-zone-id'));
    }

    var href = params.join('');
    this.model.set('google', href);
  },
  yahoo: function yahoo() {
    var isNewCalendarLinksEnabled = _FeatureToggleUtils.default.isFeatureEnabled('new-calendar-links');

    if (isNewCalendarLinksEnabled) {
      this.model.set('yahoo', this.getCalendarUrl('yahoo'));
      return;
    }

    var eventDuration = (this.model.get('end').getTime() - this.model.get('start').getTime()) / this.MS_IN_MINUTES;
    var description = this.model.get('description') || '';
    var urlToAdd = this.event.getAgendaUrl ? this.event.getAgendaUrl() : ''; // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm

    var yahooHourDuration = eventDuration < 600 ? '0' + Math.floor(eventDuration / 60) : Math.floor(eventDuration / 60) + '';
    var yahooMinuteDuration = eventDuration % 60 < 10 ? '0' + eventDuration % 60 : eventDuration % 60 + '';
    var yahooEventDuration = yahooHourDuration + yahooMinuteDuration; // Remove timezone from event time

    var st = this.formatTime(new Date(this.model.get('start') - this.model.get('start').getTimezoneOffset() * this.MS_IN_MINUTES)) || '';

    if (st && st.indexOf('Z') > -1) {
      st = st.substring(0, st.length - 1);
    }

    var et = '';

    if (this.eventMode) {
      et = this.formatTime(new Date(this.model.get('end') - this.model.get('end').getTimezoneOffset() * this.MS_IN_MINUTES)) || '';

      if (et && st.indexOf('Z') > -1) {
        et = st.substring(0, et.length - 1);
      }
    }

    var params = ['http://calendar.yahoo.com/?v=60&view=d&type=20', '&title=' + encodeURIComponent(this.model.get('title') || ''), '&st=' + encodeURIComponent(st), et ? '&et=' + encodeURIComponent(et) : '', '&dur=' + encodeURIComponent(yahooEventDuration || ''), '&desc=' + encodeURIComponent(description + '\n\n' + urlToAdd), '&in_loc=' + encodeURIComponent(this.model.get('address') || '')];
    var href = params.join('');
    this.model.set('yahoo', href);
  },
  ics: function ics() {
    var isNewCalendarLinksEnabled = _FeatureToggleUtils.default.isFeatureEnabled('new-calendar-links');

    if (isNewCalendarLinksEnabled) {
      this.model.set('ics', this.getCalendarUrl('ics'));
      return;
    }

    var startTime, endTime;
    var urlToAdd = this.event.getAgendaUrl ? this.event.getAgendaUrl() : document.URL;
    var params = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'URL:' + urlToAdd];
    var momentStartUTC = this.model.get('momentStartUTC');
    var momentEndUTC = this.model.get('momentEndUTC');

    if (!this.eventMode) {
      var duration = _moment.default.duration((0, _moment.default)(this.event.get('start-date')).diff((0, _moment.default)(this.event.get('local-start-date'))));

      var dif = duration.asHours();
      momentStartUTC.add(dif, 'hours');
      momentEndUTC.add(dif, 'hours');
    }

    startTime = this.formatMomentTime(momentStartUTC) + 'Z';
    endTime = this.formatMomentTime(momentEndUTC) + 'Z';
    params.push('DTSTART:' + (startTime || ''));
    params.push('DTEND:' + (endTime || ''));
    params = params.concat(['SUMMARY:' + (this.model.get('title') || ''), 'DESCRIPTION:' + (this.model.get('description') || '').replace(/\n/g, '\\n') + '\\n' + urlToAdd, 'LOCATION:' + (this.model.get('address') || '').replace(/,/g, '\\,'), 'END:VEVENT', 'END:VCALENDAR']);
    var encodedParams = encodeURIComponent(params.join('\n'));
    var href = "".concat(_config.default.eventsUrl, "/download/ical?data=").concat(encodedParams);
    this.model.set('ics', href);
  },
  render: function render() {
    var html = (0, _add_to_calendar.default)(_underscore.default.extend(this.model.toJSON(), {
      eventMode: !this.session
    }));
    this.$el.html(html);
    return this;
  }
});

var _default = AddToCalendarView;
exports.default = _default;